import React from 'react';

import { digitInputProps } from '@/widgets/OtpInputs/_components/DigitInput/models';

import { convertPersianToEnglish } from '@/utilities/convertPersianToEnglishNumber';

const Index = ({ value, onChange, onDelete, inputProps }: digitInputProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value.replace(/(?![۰-۹])\D/g, '');
        onChange(convertPersianToEnglish(newValue));
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Backspace' && value === '') {
            onDelete();
        }
    };

    return (
        <input
            type='text'
            maxLength={1}
            value={value}
            inputMode='numeric'
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            className='border-1 mx-3 h-10 w-10 rounded-lg border-solid border-gray-400 text-center text-[14px] shadow-none outline-0 focus:border-b-4
                focus:border-b-primary'
            {...inputProps}
        />
    );
};

export default Index;
